import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=d906f2b6&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=d906f2b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d906f2b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d906f2b6')) {
      api.createRecord('d906f2b6', component.options)
    } else {
      api.reload('d906f2b6', component.options)
    }
    module.hot.accept("./VehicleList.vue?vue&type=template&id=d906f2b6&scoped=true", function () {
      api.rerender('d906f2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/vehicle/VehicleList.vue"
export default component.exports